import { env } from '@/config/env';

const AUTH_UNAUTHORIZED_EVENT = 'platform-auth-unauthorized';

function getApiBaseUrl(): string {
  return env.API_BASE_URL || '/api';
}

function notifyUnauthorized(path: string) {
  if (typeof window === 'undefined') {
    return;
  }

  window.dispatchEvent(new CustomEvent(AUTH_UNAUTHORIZED_EVENT, {
    detail: { path },
  }));
}

function isUnauthorizedPlatformApiError(error: unknown) {
  return error instanceof Error && /unauthorized|not authenticated/i.test(error.message);
}

export async function platformApiFetch<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(`${getApiBaseUrl()}${path}`, {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
    ...init,
  });

  if (!response.ok) {
    if (response.status === 401) {
      notifyUnauthorized(path);
    }

    let message = `Platform API request failed: ${response.status} ${response.statusText}`;
    try {
      const payload = await response.json();
      message = payload?.error || message;
    } catch {
      // Ignore JSON parsing errors for non-JSON error responses.
    }
    throw new Error(message);
  }

  if (response.status === 204) {
    return undefined as T;
  }

  return response.json() as Promise<T>;
}

export { AUTH_UNAUTHORIZED_EVENT };
export { isUnauthorizedPlatformApiError };